import { h, Fragment } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { PrinterInfo as PrinterInfoType, slaveInfo } from "../api/label-creator";
import { egzotechAgentManager } from "../App";
import { cn } from "../helpers/cn";

const tapeType: { [key: string]: string | undefined } = {
    "1": "laminated, strong adhesive, security laminated, flexible ID tape",
    "3": "security, heat shrink",
    "4": "fabric tape",
    "20": "flexible id, starry laminated",
};

export function PrinterInfo({ onChange }: { onChange?: (info: PrinterInfoType | null) => void }) {
    const fetchingTimeoutRef = useRef(null as null | number);
    const [isFethching, setIsFetching] = useState(false);
    const [printerInfo, setPrinterInfo] = useState(null as PrinterInfoType | null | undefined);
    const [refreshPrinterInfo, setRefreshPrinterInfo] = useState(0);

    useEffect(() => {
        setIsFetching(true);

        slaveInfo(egzotechAgentManager.getAgentWithModule("label-printer")!)
            .then(info => {
                setPrinterInfo(info);
                if (onChange) {
                    onChange(info);
                }
            })
            .catch(ex => {
                console.error(ex);

                setPrinterInfo(null);
                if (onChange) {
                    onChange(null);
                }
            })
            .finally(() => {
                if (fetchingTimeoutRef.current) {
                    window.clearTimeout(fetchingTimeoutRef.current);
                }

                fetchingTimeoutRef.current = window.setTimeout(() => setIsFetching(false), 800);
            });
    }, [refreshPrinterInfo]);

    return (
        <>
            {printerInfo !== null ? (
                printerInfo === undefined ? null : printerInfo.portName ? (
                    <div>
                        {isFethching ? (
                            <div class="alert info">Sprawdzanie stanu drukarki...</div>
                        ) : (
                            <div class="alert success">Połączono z drukarką</div>
                        )}
                        <div class="relative">
                            <div class={cn("printer-info-table", isFethching && "text-gray-400")}>
                                <div>Czy taśma jest włożona</div>
                                <span>{printerInfo.mediaPresent ? "Tak" : "Nie"}</span>
                                <div>Rodzaj taśmy</div>
                                <span>
                                    {!tapeType[printerInfo.mediaType.toString()]
                                        ? "Nieznana"
                                        : tapeType[printerInfo.mediaType.toString()]}
                                </span>
                                <div>Szerokość taśmy</div>
                                <span>{printerInfo.mediaWidth} mm</span>
                            </div>
                            {isFethching && (
                                <div class="absolute top-0 left-0 right-0 bottom-0 bg-[#0000007f] z-10 flex items-center justify-center">
                                    <div class="loader" />
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div class="alert error">Brak komunikacji z drukarką</div>
                )
            ) : (
                <div class="alert error">Błąd komunikacji ze stroną drukowania</div>
            )}
            <div class="refresh">
                <button type="button" onClick={() => setRefreshPrinterInfo(refreshPrinterInfo + 1)}>
                    Odśwież stan drukarki
                </button>
            </div>
        </>
    );
}
